var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import buildURL from '../../externals/axios/helpers/buildURL';
import buildFullPath from '../../externals/axios/core/buildFullPath';
import qs from '../../core/qs';
import { isFunction } from '../../core/utils';
// Sig拼接方式的版本号
var sigCatVer = '1';
// 耦合了浏览器环境
export default function sig3HocCreator(instanceConfig, secAtlasSign2) {
    function withSig3(requestFn) {
        function sig3RequestFn(requestConfig) {
            return __awaiter(this, void 0, void 0, function () {
                var config, _a, useSig3, logConfig, passParamsGenerator, logger, baseURL, fullPath, passParams, configParams, params, fullUrl, _b, _c, path, _d, search, query, requestBody, res, atlasSign, e_1;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            config = requestConfig || {};
                            _a = config.useSig3, useSig3 = _a === void 0 ? false : _a, logConfig = config.logConfig, passParamsGenerator = config.passParamsGenerator;
                            logger = (logConfig || {}).logger;
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 4, , 5]);
                            baseURL = config.baseURL || location.origin;
                            if (!(useSig3 && secAtlasSign2 && baseURL && config.url)) return [3 /*break*/, 3];
                            fullPath = buildFullPath(baseURL, config.url);
                            passParams = {};
                            try {
                                passParams = isFunction(passParamsGenerator) ? passParamsGenerator(config) : {};
                            }
                            catch (_f) { }
                            configParams = config.params || {};
                            params = __assign(__assign({}, passParams), configParams);
                            fullUrl = buildURL(fullPath, params, config.paramsSerializer);
                            _b = __read(fullUrl.split('?') || [], 2), _c = _b[0], path = _c === void 0 ? '' : _c, _d = _b[1], search = _d === void 0 ? '' : _d;
                            query = qs.parse(search);
                            query.sigCatVer = sigCatVer;
                            requestBody = config.data ? JSON.stringify(config.data) : '';
                            return [4 /*yield*/, secAtlasSign2({
                                    url: path,
                                    query: query,
                                    form: {},
                                    requestBody: requestBody,
                                })];
                        case 2:
                            res = _e.sent();
                            atlasSign = (res && res.atlasSign) || '';
                            // 附加签名
                            config.params = __assign(__assign({}, configParams), { sigCatVer: sigCatVer, __NS_sig3: atlasSign });
                            _e.label = 3;
                        case 3: return [3 /*break*/, 5];
                        case 4:
                            e_1 = _e.sent();
                            if (logger && logger.collect) {
                                // 获取签名错误日志，可能会有多种
                                logger.collect('CUSTOM', 'ESHOP_REQUEST_SIG3_ERROR', {
                                    message: (e_1 && e_1.message) || '获取签名失败',
                                    config: config,
                                });
                            }
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/, requestFn(config)];
                    }
                });
            });
        }
        return sig3RequestFn;
    }
    return withSig3;
}
//# sourceMappingURL=index.js.map